import * as React from 'react';

function SvgSwitch(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
      <path
        d="M8 0a8 8 0 110 16A8 8 0 018 0zm3.467 9H4.48c-.053 0-.107 0-.16.053-.053 0-.053.054-.107.054-.106.106-.213.266-.213.426 0 .16.053.267.16.374 0 0 0 .053.053.053l1.92 1.92c.427.427 1.067.053 1.067-.587v-1.226h4.267c.266 0 .533-.267.533-.534 0-.266-.267-.533-.533-.533zM8.8 4.77v1.226H4.533c-.266 0-.533.266-.533.533s.267.533.533.533h6.987c.053 0 .107 0 .16-.053.053 0 .053-.053.107-.053.106-.107.213-.267.213-.427a.484.484 0 00-.16-.373s0-.054-.053-.054l-1.92-1.92C9.44 3.756 8.8 4.13 8.8 4.77z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgSwitch;
